import styles from "./InputNavigation.module.css";

export default function InputNavigation({i,idx,setIdx,...props}) {
    return (
        <>
            <input
                className={styles.hideInput}
                type="radio"
                id={`page_${i}`}
                name="pagesSlider"
                value={i}
                defaultChecked={i === idx}
                onClick={() => {
                    setIdx(i);
                }}
            />
            <label htmlFor={`page_${i}`} className={styles.navInput}>

                <div className={styles.btn}>
                    <svg width="42" height="63" viewBox="0 0 42 63" fill="none" xmlns="http://www.w3.org/2000/svg"
                         className={styles.pageIn} preserveAspectRatio={"none"}>
                        <path
                            d="M0.500001 58L0.500004 5C0.500004 2.51472 2.51472 0.499999 5 0.499999L37 0.5C39.4853 0.5 41.5 2.51472 41.5 5L41.5 48.818C41.5 50.1408 40.918 51.3966 39.9086 52.2516L29.0693 61.4336C28.2565 62.1221 27.2259 62.5 26.1607 62.5L5 62.5C2.51472 62.5 0.500001 60.4853 0.500001 58Z"
                            fill="#142432" stroke="#7991C4"/>
                    </svg>
                    <span>{i + 1}</span>
                </div>
                <svg width="50" height="70" viewBox="0 0 50 70" fill="none" xmlns="http://www.w3.org/2000/svg"
                     className={styles.pageOut} preserveAspectRatio={"none"}>
                    <path
                        d="M0.5 65L0.500004 5C0.500004 2.51472 2.51472 0.499998 5 0.499998L45 0.5C47.4853 0.5 49.5 2.51471 49.5 5L49.5 54.3962C49.5 55.7723 48.8704 57.0727 47.7909 57.9261L34.379 68.53C33.5844 69.1582 32.6011 69.5 31.5881 69.5L5 69.5C2.51472 69.5 0.5 67.4853 0.5 65Z"
                        fill="#92AFAE" stroke="#7991C4"/>
                </svg>
            </label>
        </>
    )
}